<script lang="ts">
  import { levelIn, levelOut } from '~/animations.svelte';
  import Arc from './Arc.svelte';

  // https://stackoverflow.com/questions/5737975/circle-drawing-with-svgs-arc-path/10477334#10477334
  type Props = {
    marquee?: string;
    radius: number;
    innerRadius: number;
  };
  const props: Props = $props();
  const TEXT_RADIUS_MULT = 0.55;
  const marqueeRadius = $derived(props.innerRadius * TEXT_RADIUS_MULT);
  const text = $derived(props.marquee?.split(' ').slice(1).join(' '));
</script>

{#key props.marquee}
  <g in:levelIn out:levelOut>
    {#if props.marquee}
      <Arc radius={marqueeRadius} x={props.radius} y={props.radius}>
        <text class="marquee" dx={(3 * marqueeRadius * Math.PI) / 2} dy={8}>
          <textPath xlink:href="#streak-path">
            {text}
          </textPath>
        </text>
      </Arc>
    {/if}
  </g>
{/key}

<style lang="scss">
  .marquee {
    font-size: 1rem;
    font-weight: bold;
    fill: currentColor;
    text-anchor: middle;
  }
</style>
